import { useEffect, useState } from 'react';

import { fetchDefaultLanding, LandingKey } from '@/config/landing';
import HomeIndex from '@/views/home';
import AiHomeIndex from '@/views/ai-home';
import MainIndex from '@/views/main';

/**
 * 루트 경로(/) 진입점.
 * site-config.json 의 defaultLanding 값에 따라 공공데이터 메인 또는 AI 랜딩을 렌더한다.
 * 설정 로드 전에는 짧은 스플래시를 보여 잘못된 랜딩이 깜빡이는 것을 방지한다.
 */
export default function LandingRouter() {
  const [landing, setLanding] = useState<LandingKey | null>(null);

  useEffect(() => {
    let active = true;
    fetchDefaultLanding().then((key) => {
      if (active) setLanding(key);
    });
    return () => {
      active = false;
    };
  }, []);

  if (landing === null) {
    return <div className="landing-splash" />;
  }

  if (landing === 'main') return <MainIndex />;
  return landing === 'ai' ? <AiHomeIndex /> : <HomeIndex />;
}
